import { render, staticRenderFns } from "./PackageCheckout.vue?vue&type=template&id=2ecf04a8&scoped=true&"
import script from "./PackageCheckout.vue?vue&type=script&lang=js&"
export * from "./PackageCheckout.vue?vue&type=script&lang=js&"
import style0 from "./PackageCheckout.vue?vue&type=style&index=0&id=2ecf04a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecf04a8",
  null
  
)

export default component.exports